




















































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";

import MyList from "@/mixins/list";

import Add from "./authuser_add.vue";
import Edit from "./authuser_edit.vue";

@Component({
  components: {
    Add,
    Edit
  }
})
export default class extends Mixins(MyList) {
  @Prop() stadiumId!: number;

  dispatchType = "stadium/authuserlist";

  deleteConfirmContent = "确认要删除该授权吗？";

  dispatchTypeDelete = "stadium/deleteauthuser";

  columns: any[] = [
    { title: "编号", dataIndex: "id" },
    { title: "被授权者手机号", dataIndex: "mobile" },
    { title: "被授权人姓名", dataIndex: "username" },
    { title: "截止日期", dataIndex: "effect_time_end" },
    { title: "备注", scopedSlots: { customRender: "remark" } },
    { title: "操作", scopedSlots: { customRender: "action" } }
  ];

  mounted() {
    this.loadData({ stadium_id: this.stadiumId }, false);
  }
}
